import { Alert, Button, Snackbar, useMediaQuery } from '@mui/material';
import axios from 'axios';
import download from 'downloadjs';
import { useAppDispatch, useAppSelector } from '../../../stores/hooks';
import { useStyles } from './DownloadDataMUI';
/* eslint-disable no-unused-vars */
/* eslint-disable prefer-const */
import { PictureAsPdf, Storage, TableChart } from '@mui/icons-material';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import LoadingButton from '@mui/lab/LoadingButton';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import LogoImg from '../../../assets/img/logo-prod.png';
import { setPosition } from '../../../stores/slices/mapSlice';
// import EUFlagImg from '../../../assets/img/eu_flag.jpg';
import moment from 'moment';
import { svgAsPngUri } from 'save-svg-as-png';
import { setLoadingPDF } from '../../../stores/slices/dashboardSlice';
import { setCollapse, setCollapses, setDownload } from '../../../stores/slices/graphSlice';
import { drugAcronymsOpposite, drugsKP, drugsNG, drugsST, ngonoSusceptibleRule } from '../../../util/drugs';
import { getGraphCards } from '../../../util/graphCards';
import { imgOnLoadPromise } from '../../../util/imgOnLoadPromise';
import { mapLegends } from '../../../util/mapLegends';
import { variableGraphOptions, variableGraphOptionsNG } from '../../../util/convergenceVariablesOptions';
// import { drugsKP, drugsST, drugsNG } from '../../../util/drugs';
import Papa from 'papaparse/papaparse.js';
import {
  colorForDrugClassesKP,
  colorForDrugClassesNG,
  colorForDrugClassesST,
  colorForMarkers,
} from '../../../util/colorHelper';
import { variablesOptions } from '../../../util/convergenceVariablesOptions';
import {
  getDEcoliTexts,
  getEcoliTexts,
  getIntsTexts,
  getKlebsiellaTexts,
  getNgonoTexts,
  getSalmonellaTexts,
  getSaureusTexts,
  getSentericaintsTexts,
  getShigeTexts,
  getStrepneumoTexts,
} from '../../../util/reportInfoTexts';
import { getColorForDrug } from '../Graphs/graphColorHelper';
import { PDFPreviewModal } from './PDFPreviewModal';
import domtoimage from 'dom-to-image-more';

let columnsToRemove = [
  'azith_pred_pheno',
  'PROJECT ACCESSION',
  'COUNTRY_ONLY',
  'REGION_IN_COUNTRY',
  'LOCATION',
  'ACCURACY',
  'LATITUDE',
  'LONGITUDE',
  'REFERENCE',
  'MLST ST (EnteroBase)',
  'MLST PROFILE (EnteroBase)',
  'GENOTYPHI SNPs CALLED',
  'Genome ID',
  'Version',
  'Organism Name',
  'Organism ID',
  'Species Name',
  'Species ID',
  'Genus Name',
  'Genus ID',
  'Reference ID',
  'Matching Hashes',
  'p-Value',
  'Mash Distance',
  'cip_pred_pheno',
  'dcs_category',
  'amr_category',
  'num_qrdr',
  'num_acrb',
  'ESBL_category',
  'chloramphenicol_category',
  'tetracycline_category',
  'cip_pheno_qrdr_gene',
  'dcs_mechanisms',
  'num_amr_genes',
  'dfra_any',
  'sul_any',
  'co_trim',
  'GENOTYPE_SIMPLE',
  'h58_genotypes',
  'COUNTRY OF ORIGIN',
  'AGE',
  'TRAVEL COUNTRY',
  'TRAVEL ASSOCIATED',
  'parE_D420N',
  'parE_L416F',
  '_id',
  'LATITUDE',
  'LONGITUDE',
];

let columnsToRemoveNonTyphi = [
  'PURPOSE OF SAMPLING',
  'CipNS',
  'CipR',
  'AzithR1',
  'AzithR2',
  'AzithR3',
  'AzithR4',
  'AzithR5',
  'AzithR6',
  'AzithR7',
  'AzithR8',
  'AzithR9',
  'AzithR10',
  'AzithR11',
  'Source Niche',
  'Continent',
  'Serological Group',
  'Serotype, EcoR Cluster',
  'Sample ID',
  'ST Complex',
  'Subspecies',
  'source_niche',
  'Source Niche',
  'AbST',
  'Aerobactin',
  'Alternative sample name 1',
  'CbST',
  'Chr_ST',
  'K_locus_problems',

  'Omp_mutations',
  'Salmochelin',
  'YbST',
  'Yersiniabactin',
  'clbA',
  'clbB',
  'clbC',
  'clbD',
  'clbE',
  'clbF',
  'clbG',
  'clbH',
  'clbI',
  'clbL',
  'clbM',
  'clbN',
  'clbO',
  'clbP',
  'clbQ',
  'contig_count',
  'fyuA',
  'gapA',
  'infB',
  'iroB',
  'iroC',
  'iroD',
  'iroN',
  'irp1',
  'irp2',
  'iucA',
  'iucB',
  'iucC',
  'iucD',
  'iutA',
  'largest_contig',
  'pgi',
  'phoE',
  'resistance_score',
  'rmpA',
  'rmpA2',
  'rmpC',
  'rmpD',
  'rpoB',
  'species',
  'spurious_resistance_hits',
  'spurious_virulence_hits',
  'tonB',
  'total_size',
  'truncated_resistance_hits',
  'virulence_score',
  'wzi',
  'ybtA',
  'ybtE',
  'ybtP',
  'ybtQ',
  'ybtS',
  'ybtT',
  'ybtU',
  'ybtX',
];

export const DownloadData = () => {
  const classes = useStyles();
  const matches1000 = useMediaQuery('(max-width:1000px)');
  const [loadingCSV, setLoadingCSV] = useState(false);
  // const [loadingPDF, setLoadingPDF] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [capturedReportData, setCapturedReportData] = useState(null);
  const { t } = useTranslation();

  const dispatch = useAppDispatch();
  const organism = useAppSelector(state => state.dashboard.organism);
  const actualCountry = useAppSelector(state => state.dashboard.actualCountry);
  const actualRegion = useAppSelector(state => state.dashboard.actualRegion);
  const listPMID = useAppSelector(state => state.dashboard.listPMID);
  const PMID = useAppSelector(state => state.dashboard.PMID);
  const actualGenomes = useAppSelector(state => state.dashboard.actualGenomes);
  const actualTimeInitial = useAppSelector(state => state.dashboard.actualTimeInitial);
  const actualTimeFinal = useAppSelector(state => state.dashboard.actualTimeFinal);
  const mapView = useAppSelector(state => state.map.mapView);
  const dataset = useAppSelector(state => state.map.dataset);
  const determinantsGraphDrugClass = useAppSelector(state => state.graph.determinantsGraphDrugClass);
  const trendsGraphDrugClass = useAppSelector(state => state.graph.trendsGraphDrugClass);
  const KODiversityGraphView = useAppSelector(state => state.graph.KODiversityGraphView);
  const colorPallete = useAppSelector(state => state.dashboard.colorPallete);
  const genotypesForFilter = useAppSelector(state => state.dashboard.genotypesForFilter);
  const convergenceGroupVariable = useAppSelector(state => state.graph.convergenceGroupVariable);
  const convergenceColourVariable = useAppSelector(state => state.graph.convergenceColourVariable);
  const convergenceColourPallete = useAppSelector(state => state.graph.convergenceColourPallete);
  const prevalenceMapViewOptionsSelected = useAppSelector(state => state.graph.prevalenceMapViewOptionsSelected);
  const drugResistanceGraphView = useAppSelector(state => state.graph.drugResistanceGraphView);
  const captureDRT = useAppSelector(state => state.dashboard.captureDRT);
  const captureRFWG = useAppSelector(state => state.dashboard.captureRFWG);
  const captureRDWG = useAppSelector(state => state.dashboard.captureRDWG);
  const captureGD = useAppSelector(state => state.dashboard.captureGD);
  const genotypesForFilterSelected = useAppSelector(state => state.dashboard.genotypesForFilterSelected);
  const genotypesForFilterSelectedRD = useAppSelector(state => state.dashboard.genotypesForFilterSelectedRD);
  const topGenesSlice = useAppSelector(state => state.graph.topGenesSlice);
  const topGenotypeSlice = useAppSelector(state => state.graph.topGenotypeSlice);
  const topColorSlice = useAppSelector(state => state.graph.topColorSlice);
  const endtimeGD = useAppSelector(state => state.graph.endtimeGD);
  const starttimeGD = useAppSelector(state => state.graph.starttimeGD);
  const endtimeDRT = useAppSelector(state => state.graph.endtimeDRT);
  const starttimeDRT = useAppSelector(state => state.graph.starttimeDRT);
  const actualGenomesGD = useAppSelector(state => state.graph.actualGenomesGD);
  const actualGenomesDRT = useAppSelector(state => state.graph.actualGenomesDRT);
  const starttimeRDT = useAppSelector(state => state.graph.starttimeRDT);
  const endtimeRDT = useAppSelector(state => state.graph.endtimeRDT);
  const actualGenomesRDT = useAppSelector(state => state.graph.actualGenomesRDT);
  const endTimeKOT = useAppSelector(state => state.graph.endTimeKOT);
  const startTimeKOT = useAppSelector(state => state.graph.startTimeKOT);
  const actualGenomesKOT = useAppSelector(state => state.graph.actualGenomesKOT);
  const selectedLineages = useAppSelector(state => state.dashboard.selectedLineages);
  const coloredOptions = useAppSelector(state => state.graph.coloredOptions);
  const drugClass = useAppSelector(state => state.graph.drugClass); // Drug class selected in the graph for PDF
  const drugGene = useAppSelector(state => state.graph.drugGene); // Drug gene selected in the graph for PDF
  //loadingPDF:  Loading state for PDF generation and temp change the visibility of the Geo Comp Heatmap
  // to show all the selected values to take a correct screenshot
  const loadingPDF = useAppSelector(state => state.dashboard.loadingPDF);
  const KOForFilterSelected = useAppSelector(state => state.dashboard.KOForFilterSelected);
  const colorPalleteKO = useAppSelector(state => state.dashboard.colorPalleteKO);
  const KOTrendsGraphPlotOption = useAppSelector(state => state.graph.KOTrendsGraphPlotOption);
  const customDropdownMapViewNG = useAppSelector(state => state.graph.customDropdownMapViewNG);
  const colorPalleteCgST = useAppSelector(state => state.dashboard.colorPalleteCgST);
  const colorPalleteSublineages = useAppSelector(state => state.dashboard.colorPalleteSublineages);
  const distributionGraphVariable = useAppSelector(state => state.graph.distributionGraphVariable);
  const colourPattern = useAppSelector(state => state.dashboard.colourPattern);
  const convergenceData = useAppSelector(state => state.graph.convergenceData);
  const currentSliderValueCM = useAppSelector(state => state.graph.currentSliderValueCM);
  const bubbleMarkersYAxisType = useAppSelector(state => state.graph.bubbleMarkersYAxisType);
  const bubbleHeatmapGraphVariable = useAppSelector(state => state.graph.bubbleHeatmapGraphVariable);
  const bubbleKOHeatmapGraphVariable = useAppSelector(state => state.graph.bubbleKOHeatmapGraphVariable);
  const bubbleKOYAxisType = useAppSelector(state => state.graph.bubbleKOYAxisType);

  async function handleClickDownloadDatabase() {
    let firstName, secondName;
    if (organism === 'styphi') {
      firstName = 'Salmonella';
      secondName = 'Typhi';
    } else if (organism === 'kpneumo') {
      firstName = 'Klebsiella';
      secondName = 'pneumoniae';
    } else if (organism === 'ngono') {
      firstName = 'Neisseria';
      secondName = 'gonorrhoeae';
    } else if (organism === 'shige') {
      firstName = 'Shigella';
      secondName = '+ EIEC';
    } else if (organism === 'decoli') {
      firstName = 'Escherichia coli';
      secondName = '(diarrheagenic)';
    } else if (organism === 'sentericaints') {
      firstName = 'Salmonella';
      secondName = '(invasive non-typhoidal)';
    } else if (organism === 'senterica') {
      firstName = 'Salmonella enterica';
      secondName = '(non-typhoidal)';
    } else if (organism === 'saureus') {
      firstName = 'Staphylococcus';
      secondName = 'aureus';
    } else if (organism === 'strepneumo') {
      firstName = 'Streptococcus';
      secondName = 'pneumoniae';
    }
    if (organism !== 'styphi') columnsToRemove = [...columnsToRemoveNonTyphi, ...columnsToRemove];
    setLoadingCSV(true);

    try {
      const res = await axios.post(`/api/file/download`, { organism });

      const parsed = Papa.parse(res.data, {
        header: false,
        skipEmptyLines: true,
      });

      const lines = parsed.data;

      const replacements = {
        COUNTRY_ONLY: 'Country',
        NAME: 'Name',
        DATE: 'Date',
        GENOTYPE: 'Genotype',
        source_type: 'Source_type',
        accession: 'Accession',
        ACCESSION: 'Accession',
        'dashboard view': 'Dashboard view',
      };

      lines[0] = lines[0].map(header => replacements[header] || header);

      // columns to remove
      const indexesToRemove = columnsToRemove
        .map(col => lines[0].indexOf(col))
        .filter(index => index !== -1)
        .sort((a, b) => b - a); // Reverse sort for safe removal

      // Remove columns
      const newLines = lines.map(row => row.filter((_, i) => !indexesToRemove.includes(i)));

      // create TSV
      const newTSV = newLines.map(row => row.join('\t')).join('\n');

      // Download
      download(newTSV, `AMRnet ${firstName} ${secondName} Database.tsv`);
    } catch (error) {
      console.error('Error downloading database:', error);
    } finally {
      setLoadingCSV(false);
      dispatch(setLoadingPDF(false));
    }
  }

  function getOrganismCards() {
    const cards = getGraphCards(t);
    return cards.filter(card => card.organisms.includes(organism));
  }

  function getGenotypeColor(genotype) {
    return currentColorPallete[genotype] || colorPalleteKO[KOTrendsGraphPlotOption][genotype] || '#F5F4F6';
  }
  const currentColorPallete = useMemo(() => {
    const isSpecialOrganism = organism === 'kpneumo' || organism === 'ngono';

    if (!isSpecialOrganism) {
      return colorPallete;
    }

    if (distributionGraphVariable === 'Sublineage') {
      return colorPalleteSublineages;
    }

    if (distributionGraphVariable === 'cgST' || distributionGraphVariable === 'NG-MAST TYPE') {
      return colorPalleteCgST;
    }

    return colorPallete;
  }, [colorPallete, colorPalleteCgST, colorPalleteSublineages, distributionGraphVariable, organism]);

  function getDrugClassesBars() {
    switch (organism) {
      case 'styphi':
        return colorForDrugClassesST[determinantsGraphDrugClass];
      case 'kpneumo':
        return colorForDrugClassesKP[determinantsGraphDrugClass];
      case 'ngono':
        return colorForDrugClassesNG[determinantsGraphDrugClass];
      default:
        return '';
    }
  }

  function formatDate(date) {
    return moment(date).format('ddd MMM DD YYYY HH:mm');
  }
  let Page = 0;
  function drawFooter({ document, pageHeight, pageWidth, date }) {
    Page++;
    document.setFontSize(10);
    document.line(0, pageHeight - 26, pageWidth, pageHeight - 24);
    document.text(`Source: amrnet.org`, 16, pageHeight - 10, { align: 'left' });
    document.text(`Page:${Page}`, pageWidth - 16, pageHeight - 10, { align: 'right' });
    document.setFontSize(12);
  }

  function drawHeader({ document, pageWidth }) {
    document.setFontSize(8);
    document.line(0, 26, pageWidth, 26);
    let note = `NOTE: these estimates are derived from unfiltered genome data deposited in public databases, which reflects a strong bias towards sequencing of resistant strains. This will change in future updates.`;
    if (organism === 'senterica') {
      note += ' Salmonella Typhi has a dedicated dashboard curated by TyphiNET.';
    }
    // Only show for organisms other than styphi or ngono
    if (organism !== 'styphi' && organism !== 'ngono') {
      document.text(note, 16, 10, { align: 'left', maxWidth: pageWidth - 16 });
    }
    document.setFontSize(12);
  }

  // function drawHeader({ document, pageWidth}) {
  //   document.setFontSize(10);
  //   document.line(0, 26, pageWidth, 26);
  //   document.text(`NOTE: these estimates are derived from unfiltered genome data deposited in public databases, which reflects a strong bias towards sequencing of resistant strains. This will change in future updates.`, 160, 20, { align: 'center', maxWidth: pageWidth - 36  });
  //   document.setFontSize(12);
  // }
  function drawLegend({
    document, // jsPDF document instance
    legendData,
    factor,
    rectY,
    isGenotype = false,
    isDrug = false,
    isVariable = false,
    isGen = false,
    xSpace,
    topConvergenceData = [], // For convergence graph pattern sync
    genotypesForFilterSelected = [], // For genotype pattern sync
    KOForFilterSelected = [], // For KO pattern sync
    factorMultiply = 3,
  }) {
    // --- shared pattern configuration ---
    const patternTypes = ['solid', 'stripes', 'dots', 'cross'];
    const getPatternTypeForGenotype = (
      legend,
      topConvergenceData = [],
      genotypesForFilterSelected = [],
      KOForFilterSelected = [],
    ) => {
      let patternIndex = 0;

      if (topConvergenceData?.length > 0) {
        const idx = topConvergenceData.findIndex(item => item.colorLabel === legend);
        if (idx !== -1) patternIndex = idx % patternTypes.length;
      } else if (genotypesForFilterSelected?.length > 0) {
        const idx = genotypesForFilterSelected.indexOf(legend);
        if (idx !== -1) patternIndex = idx % patternTypes.length;
      } else if (KOForFilterSelected?.length > 0) {
        const idx = KOForFilterSelected.indexOf(legend);
        if (idx !== -1) patternIndex = idx % patternTypes.length;
      }

      return patternTypes[patternIndex];
    };

    // --- main legend drawing loop ---
    legendData.forEach((legend, i) => {
      const yFactor = (i % factor) * 10;
      const xFactor = Math.floor(i / factor) * xSpace;

      // Determine if we should use patterns (for genotypes OR variables)
      const usePattern = colourPattern && (isGenotype || isVariable);

      if (usePattern) {
        // Determine pattern type
        const patternType = getPatternTypeForGenotype(
          legend,
          topConvergenceData,
          genotypesForFilterSelected,
          KOForFilterSelected,
        );

        // Determine base color
        let baseColor;
        if (isGenotype) {
          if (legend === 'Other') {
            baseColor = '#F5F4F6';
          } else if (KOForFilterSelected && KOForFilterSelected.includes(legend)) {
            const colorMap = colorPalleteKO[KOTrendsGraphPlotOption] || {};
            baseColor = colorMap[legend] || getGenotypeColor(legend);
          } else {
            baseColor = getGenotypeColor(legend);
          }
        } else if (isVariable) {
          baseColor = convergenceColourPallete[legend] || '#F5F4F6';
        } else {
          baseColor = '#F5F4F6';
        }

        // --- create high-res pattern canvas ---
        const patternCanvas = window.document.createElement('canvas');
        const patternCtx = patternCanvas.getContext('2d');
        patternCtx.imageSmoothingEnabled = true;
        patternCtx.imageSmoothingQuality = 'high';

        const patternResolution = 64; // internal pixel size for clarity
        const logicalSize = 8; // logical units (like SVG viewBox)
        const scale = patternResolution / logicalSize;

        patternCanvas.width = patternResolution;
        patternCanvas.height = patternResolution;
        patternCtx.scale(scale, scale);

        // --- draw pattern background ---
        patternCtx.fillStyle = baseColor;
        patternCtx.fillRect(0, 0, logicalSize, logicalSize);

        // --- draw pattern details (match SVG logic) ---
        switch (patternType) {
          case 'solid':
            // already filled
            break;

          case 'stripes':
            patternCtx.strokeStyle = 'rgba(255, 255, 255, 0.5)';
            patternCtx.lineWidth = 0.5;
            patternCtx.beginPath();
            for (let j = -8; j < 16; j += 3) {
              patternCtx.moveTo(j, 8);
              patternCtx.lineTo(j + 8, 0);
            }
            patternCtx.stroke();
            break;

          case 'dots':
            patternCanvas.width = 6;
            patternCanvas.height = 6;

            patternCtx.fillStyle = baseColor;
            patternCtx.fillRect(0, 0, 6, 6);

            patternCtx.fillStyle = 'rgba(255, 255, 255, 0.5)';

            // 2x2 grid of small dots
            const dotRadius = 0.5;
            for (let x = 1.5; x <= 4.5; x += 3) {
              for (let y = 1.5; y <= 4.5; y += 3) {
                patternCtx.beginPath();
                patternCtx.arc(x, y, dotRadius, 0, 2 * Math.PI);
                patternCtx.fill();
              }
            }

            break;

          case 'cross':
            patternCtx.strokeStyle = 'rgba(255, 255, 255, 0.5)';
            patternCtx.lineWidth = 0.5;
            patternCtx.beginPath();
            for (let j = -8; j < 16; j += 3) {
              patternCtx.moveTo(j, 8);
              patternCtx.lineTo(j + 8, 0);
            }
            for (let j = -8; j < 16; j += 3) {
              patternCtx.moveTo(j, 0);
              patternCtx.lineTo(j + 8, 8);
            }
            patternCtx.stroke();
            break;
        }

        // --- render to PDF ---
        const patternDataUrl = patternCanvas.toDataURL('image/png');
        const rectX = 46 + xFactor;
        const rectYPos = rectY + 26 + yFactor;

        // // Draw the image as pattern box
        // document.addImage(patternDataUrl, 'PNG', rectX, rectYPos, 16, 16, undefined, 'FAST');

        // Add border
        document.setDrawColor(204, 204, 204);
        const boxSize = 8; // new smaller size

        // Draw the image as pattern box
        document.addImage(patternDataUrl, 'PNG', rectX, rectYPos, boxSize, boxSize, undefined, 'MEDIUM');

        // Add border
        document.setDrawColor(204, 204, 204);
        document.setLineWidth(0.5);
        document.rect(rectX, rectYPos, boxSize, boxSize);
      } else {
        // --- non-pattern (color only) legend items ---
        let fillColor;

        if (isGenotype) {
          fillColor = legend === 'Other' ? '#F5F4F6' : getGenotypeColor(legend);
        } else if (isDrug) {
          fillColor = getColorForDrug(legend, colourPattern);
        } else if (isVariable) {
          fillColor = convergenceColourPallete[legend] || '#F5F4F6';
        } else if (isGen) {
          fillColor = i === legendData.length - 1 ? '#F5F4F6' : colorForMarkers(i, colourPattern);
        } else {
          fillColor = legend.color || '#F5F4F6';
        }

        // Convert hex to RGB
        const hexToRgb = hex => {
          const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
          return result
            ? {
                r: parseInt(result[1], 16),
                g: parseInt(result[2], 16),
                b: parseInt(result[3], 16),
              }
            : { r: 245, g: 244, b: 246 };
        };

        const rgb = hexToRgb(fillColor);
        document.setFillColor(rgb.r, rgb.g, rgb.b);

        const radius = !colourPattern ? 3 : i % 2 !== 0 ? 3.5 : 3;
        const circleX = 52 + xFactor;
        const circleY = rectY + 30 + yFactor;

        document.circle(circleX, circleY, radius, 'F');
      }

      // --- text label ---
      document.setTextColor(0, 0, 0);
      const textX = usePattern ? 65 + xFactor : 61 + xFactor;
      const textY = rectY + 32 + yFactor;

      let textContent;
      if (isGenotype || isDrug || isVariable) {
        textContent = String(legend).replaceAll('β', 'B');
      } else if (isGen) {
        textContent = String(legend);
      } else {
        textContent = legend.name || String(legend);
      }

      document.text(textContent, textX, textY);
    });
  }

  async function handleClickDownloadPDF() {
    dispatch(setLoadingPDF(true));
    dispatch(setCollapses({ continent: true, all: true, map: true, continentP: true }));
    dispatch(setPosition({ coordinates: [0, 0], zoom: 1 }));

    try {
      if (genotypesForFilter.length <= 0) return;

      // Resolve organism display names
      const nameMap = {
        styphi: ['Salmonella', 'Typhi'],
        kpneumo: ['Klebsiella', 'pneumoniae'],
        ngono: ['Neisseria', 'gonorrhoeae'],
        shige: ['Shigella', '+ EIEC'],
        senterica: ['Salmonella enterica', '(non-typhoidal)'],
        ecoli: ['Escherichia', 'coli'],
        decoli: ['Escherichia coli', '(diarrheagenic)'],
        sentericaints: ['Salmonella', '(invasive non-typhoidal)'],
        saureus: ['Staphylococcus', 'aureus'],
        strepneumo: ['Streptococcus', 'pneumoniae'],
      };
      const [firstName, secondName] = nameMap[organism] ?? ['Unknown', 'organism'];

      // Resolve info texts for PDF info page. The get*Texts() functions
      // now read the `report.<organism>` arrays from i18next, so the PDF
      // copy follows the user's selected dashboard language (with English
      // fallback for any locale that hasn't been translated yet).
      const textsMap = {
        styphi: () => getSalmonellaTexts(t),
        kpneumo: () => getKlebsiellaTexts(t),
        ngono: () => getNgonoTexts(t),
        shige: () => getShigeTexts(t),
        senterica: () => getSentericaintsTexts(t),
        ecoli: () => getEcoliTexts(t),
        decoli: () => getDEcoliTexts(t),
        sentericaints: () => getIntsTexts(t),
        saureus: () => getSaureusTexts(t),
        strepneumo: () => getStrepneumoTexts(t),
      };
      const texts = textsMap[organism]?.() ?? [];

      // Resolve map view label
      const mapLegend = mapLegends.find(x => x.value === mapView);
      const actualMapView = mapLegend ? (mapLegend.labelKey ? t(mapLegend.labelKey) : mapLegend.label) : mapView;

      // Wait for DOM to fully paint after collapse/position dispatch
      await new Promise(r => setTimeout(r, 1200));

      // Capture map (SVG)
      let mapImage = null;
      const mapEl = document.getElementById('global-overview-map');
      if (mapEl) {
        mapImage = await svgAsPngUri(mapEl, { backgroundColor: 'white', width: 1200, left: -200 });
      }

      async function captureElement(id) {
        const el = document.getElementById(id);
        if (!el) return null;

        const isHeatmap = ['BAMRH', 'BAMRPH', 'HSG2', 'BKOH', 'BG', 'BHP'].includes(id);

        if (isHeatmap) {
          const originalOverflow = el.style.overflow;
          const originalWidth    = el.style.width;
          const originalHeight   = el.style.height;

          el.style.overflow = 'visible';
          // Extra 200px width so the rightmost column's rotated header (which
          // extends beyond the SVG edge) falls inside the capture area.
          el.style.width  = (el.scrollWidth  + 200) + 'px';
          el.style.height = (el.scrollHeight + 100) + 'px';

          // Set overflow:visible on all SVGs so rotated text outside the SVG
          // viewBox can paint into the extra space above/beside the chart.
          const savedSvgOverflows = [];
          el.querySelectorAll('svg').forEach(svg => {
            savedSvgOverflows.push({ node: svg, overflow: svg.style.overflow });
            svg.style.overflow = 'visible';
          });

          await new Promise(r => setTimeout(r, 200));
          const dataUrl = await domtoimage.toPng(el, { bgcolor: 'white' });

          el.style.overflow = originalOverflow;
          el.style.width    = originalWidth;
          el.style.height   = originalHeight;
          savedSvgOverflows.forEach(s => { s.node.style.overflow = s.overflow; });

          const img = new Image();
          await new Promise(r => { img.onload = r; img.src = dataUrl; });
          return { dataUrl, width: img.naturalWidth / 2, height: img.naturalHeight / 2 };
        }

        // Force minimum dimensions so recharts re-renders at the desktop layout size.
        // min-width overrides the viewport-based media query width; min-height overrides
        // the small-screen fixed height (e.g. 460px) since inline > class specificity.
        const savedMinWidth  = el.style.minWidth;
        const savedMinHeight = el.style.minHeight;
        el.style.minWidth  = '1000px';
        el.style.minHeight = '560px';
        // Wait longer so Recharts fully re-renders at the new size before we
        // touch anything else (shorter wait caused bar/axis misalignment).
        await new Promise(r => setTimeout(r, 500));
        // Skip SVG overflow: bar/line chart SVGs don't need it (overflow:visible
        // on Recharts SVGs can shift the dom-to-image capture boundary, causing
        // bars to appear misaligned with year ticks). Only radar charts need it.
        const restore = expandForCapture(el, { skipSvgOverflow: true });
        await new Promise(r => setTimeout(r, 300));
        const dataUrl = await domtoimage.toPng(el, { bgcolor: '#ffffff' });
        restore();
        el.style.minWidth  = savedMinWidth;
        el.style.minHeight = savedMinHeight;
        const img = new Image();
        await new Promise(r => { img.onload = r; img.src = dataUrl; });
        return { dataUrl, width: img.naturalWidth / 2, height: img.naturalHeight / 2 };
      }

      // Helper: capture a DOM element as { dataUrl, width, height }
      // async function captureElement(id) {
      //   const el = document.getElementById(id);
      //   if (!el) return null;
      //   // const target = id === 'BAMRH' ? (el.parentElement ?? el) : el;
      //   const canvas = await html2canvas(el, {
      //     backgroundColor: 'white',
      //     scale: 2,
      //     useCORS: true,
      //     scrollX: 0,
      //     scrollY: 0,
      //   });
      //   return { dataUrl: canvas.toDataURL('image/png'), width: canvas.width / 2, height: canvas.height / 2 };
      // }

      // Capture Geographic Comparisons
      const bgCapture = await captureElement('BG');

      // Capture Pathotype / Serotype graph (for shige, decoli, ecoli, sentericaints)
      let bhpCapture = null;
      if (['sentericaints', 'decoli', 'shige', 'ecoli'].includes(organism)) {
        bhpCapture = await captureElement('BHP');
      }

      // Capture each organism graph card
      const cards = getOrganismCards();
      const capturedGraphs = [];
      const drugInfo = (id) => {
        if (id.includes('BAMRH')) return `Genotype: ${organism === 'ngono'
                  ? variableGraphOptionsNG.find(option => option.value === distributionGraphVariable)?.label
                  : organism === 'kpneumo' ? variablesOptions.find(option => option.value === distributionGraphVariable)?.label : null} | Drug: ${bubbleMarkersYAxisType}`;
        if (id.includes('RDT'))   return `Drug class: ${trendsGraphDrugClass}`;
        if (id.includes('convergence-graph')) return `Convergence group: ${convergenceGroupVariable}`;
        if (id.includes('BKOH'))   return `Genotype: ${organism === 'ngono'
                  ? variableGraphOptionsNG.find(option => option.value === distributionGraphVariable)?.label
                  : variablesOptions.find(option => option.value === bubbleKOHeatmapGraphVariable)?.label} | K/O Type: ${bubbleKOYAxisType}`;
        if (id.includes('HSG2'))   return `Genotype: ${organism === 'ngono'
                  ? variableGraphOptionsNG.find(option => option.value === distributionGraphVariable)?.label
                  : organism === 'kpneumo' ? variablesOptions.find(option => option.value === bubbleHeatmapGraphVariable)?.label : null}`;
        if (id.includes('GD'))   return `Genotype: ${organism === 'ngono'
                  ? variableGraphOptionsNG.find(option => option.value === distributionGraphVariable)?.label
                  : organism === 'kpneumo' ? variablesOptions.find(option => option.value === distributionGraphVariable)?.label : null}`;
        if (id.includes('KOT'))   return `K/O Type: ${bubbleKOYAxisType}`;
        return null;
      };

      for (const card of cards) {
        dispatch(setDownload(true));
        const capture = await captureElement(card.id);
        if (!capture) continue;
        capturedGraphs.push({
          ...card,
          image:    capture.dataUrl,
          width:    capture.width,
          height:   capture.height,
          subtitle: buildCardSubtitle(card.id),
          drugInfo: drugInfo(card.id),
        });
      }
      dispatch(setDownload(false));

      // ── Helper: expand all overflow-constrained descendants so domtoimage
      //    captures the full content regardless of screen size. Returns a
      //    restore function that reverts every inline-style change.
      //
      //    skipSvgOverflow: pass true for bar/line charts. Setting overflow:visible
      //    on Recharts SVGs shifts the dom-to-image capture boundary for those chart
      //    types and causes bars to appear misaligned with axis tick labels. Only
      //    radar/polar charts (PolarAngleAxis) genuinely need SVG overflow:visible.
      function expandForCapture(el, { skipSvgOverflow = false } = {}) {
        const saved = [];

        // HTML: expand any element whose scroll dimensions exceed its visible box
        const walk = node => {
          if (!(node instanceof HTMLElement)) return;
          const hasScrollX = node.scrollWidth > node.clientWidth + 2;
          const hasScrollY = node.scrollHeight > node.clientHeight + 2;
          if (hasScrollX || hasScrollY) {
            const cs = window.getComputedStyle(node);
            if (cs.overflowX !== 'visible' || cs.overflowY !== 'visible') {
              saved.push({ node, overflowX: node.style.overflowX, overflowY: node.style.overflowY, width: node.style.width, height: node.style.height });
              if (hasScrollX) { node.style.overflowX = 'visible'; node.style.width  = node.scrollWidth  + 'px'; }
              if (hasScrollY) { node.style.overflowY = 'visible'; node.style.height = node.scrollHeight + 'px'; }
            }
          }
          Array.from(node.children).forEach(walk);
        };
        walk(el);

        // SVG: only set overflow:visible when needed for polar/radar charts whose
        // PolarAngleAxis tick labels extend outside the SVG viewBox. Skip for
        // bar/line charts to avoid shifting the capture boundary.
        if (!skipSvgOverflow) {
          el.querySelectorAll('svg').forEach(svg => {
            const cs = window.getComputedStyle(svg);
            if (cs.overflow !== 'visible') {
              saved.push({ node: svg, isSvg: true, savedOverflow: svg.style.overflow });
              svg.style.overflow = 'visible';
            }
          });
        }

        return () => saved.forEach(s => {
          if (s.isSvg) {
            s.node.style.overflow = s.savedOverflow;
          } else {
            s.node.style.overflowX = s.overflowX;
            s.node.style.overflowY = s.overflowY;
            s.node.style.width  = s.width;
            s.node.style.height = s.height;
          }
        });
      }

      // ── Helper: domtoimage capture → { dataUrl, width, height } ───────────
      async function captureWithDomtoimage(el) {
        const dataUrl = await domtoimage.toPng(el, { bgcolor: '#ffffff' });
        const img = new Image();
        await new Promise(r => { img.onload = r; img.src = dataUrl; });
        return { dataUrl, width: img.naturalWidth / 2, height: img.naturalHeight / 2 };
      }

      // ── Capture AMR Insights tabs ──────────────────────────────────────────
      const INSIGHTS_TABS = [
        { value: 'COO', label: t('amrInsights.tabs.cooccurrence') },
        { value: 'GVP', label: t('amrInsights.tabs.genomicVsPhenotypic') },
        { value: 'ATB', label: t('amrInsights.tabs.atbCorrelation') },
        { value: 'GMP', label: t('amrInsights.tabs.geneMap') },
      ];

      dispatch(setCollapse({ key: 'insights', value: true }));
      await new Promise(r => setTimeout(r, 700));

      const capturedInsights = [];
      const insightsContainer = document.getElementById('amr-insights-content');

      if (insightsContainer) {
        // On small screens the MUI Collapse may not have finished its animation
        // (or may still have overflow:hidden / height:0 inline styles) by the
        // time we reach here, causing domtoimage to capture zero-height images
        // because getBoundingClientRect() is clipped by the overflow ancestor.
        // Force every overflow-hidden ancestor (up to the Collapse root) to be
        // fully visible before we start capturing.
        const collapseRoot = insightsContainer.closest('.MuiCollapse-root');
        const savedCollapseHeight   = collapseRoot?.style?.height;
        const savedCollapseOverflow = collapseRoot?.style?.overflow;
        if (collapseRoot) {
          collapseRoot.style.height   = 'auto';
          collapseRoot.style.overflow = 'visible';
        }

        for (const tab of INSIGHTS_TABS) {
          const tabEl = document.getElementById(`amr-insights-${tab.value}`);
          if (!tabEl) continue;

          // Show only this tab; hide all others
          const tabWrappers = Array.from(insightsContainer.children);
          const savedTabStyles = tabWrappers.map(el => ({
            position: el.style.position,
            zIndex: el.style.zIndex,
            visibility: el.style.visibility,
          }));
          tabWrappers.forEach(el => {
            if (el === tabEl) {
              el.style.position = 'relative';
              el.style.zIndex = '1';
              el.style.visibility = 'visible';
            } else {
              el.style.position = 'absolute';
              el.style.visibility = 'hidden';
            }
          });

          // Force minimum dimensions so Recharts re-renders at desktop size.
          // minHeight is especially important on small screens where the chart
          // container collapses due to viewport-based media queries.
          const savedTabMinWidth  = tabEl.style.minWidth;
          const savedTabMinHeight = tabEl.style.minHeight;
          tabEl.style.minWidth  = '1000px';
          tabEl.style.minHeight = '600px';
          await new Promise(r => setTimeout(r, 400));
          const restoreExpand = expandForCapture(tabEl);
          await new Promise(r => setTimeout(r, 200));

          const { dataUrl, width, height } = await captureWithDomtoimage(tabEl);

          restoreExpand();
          tabEl.style.minWidth  = savedTabMinWidth;
          tabEl.style.minHeight = savedTabMinHeight;
          tabWrappers.forEach((el, i) => {
            el.style.position   = savedTabStyles[i].position;
            el.style.zIndex     = savedTabStyles[i].zIndex;
            el.style.visibility = savedTabStyles[i].visibility;
          });

          capturedInsights.push({ tab: tab.value, label: tab.label, dataUrl, width, height });
        }

        // Restore Collapse root styles
        if (collapseRoot) {
          collapseRoot.style.height   = savedCollapseHeight;
          collapseRoot.style.overflow = savedCollapseOverflow;
        }
      }

      dispatch(setCollapse({ key: 'insights', value: false }));

      // ── Capture Radar Profile tab ──────────────────────────────────────────
      let radarCapture = null;
      const radarTabEl = document.getElementById('continent-tab-RAD');
      if (radarTabEl) {
        const bgTabEl = document.getElementById('continent-tab-BG');
        const savedRadarPos = radarTabEl.style.position;
        const savedRadarZ   = radarTabEl.style.zIndex;
        const savedBgPos    = bgTabEl?.style?.position;
        const savedBgVis    = bgTabEl?.style?.visibility;

        radarTabEl.style.position = 'relative';
        radarTabEl.style.zIndex   = '1';
        if (bgTabEl) { bgTabEl.style.position = 'absolute'; bgTabEl.style.visibility = 'hidden'; }

        // Force minimum width/height so the RadarChart re-renders at desktop
        // size. isAnimationActive={!loadingPDF} disables Recharts animation so
        // the polygon positions are final before capture. 500ms ensures the
        // ResizeObserver-triggered re-render fully commits even on slow devices.
        const savedRadarMinWidth  = radarTabEl.style.minWidth;
        const savedRadarMinHeight = radarTabEl.style.minHeight;
        radarTabEl.style.minWidth  = '1000px';
        radarTabEl.style.minHeight = '620px';
        await new Promise(r => setTimeout(r, 500));
        const restoreRadar = expandForCapture(radarTabEl, { skipSvgOverflow: true });
        await new Promise(r => setTimeout(r, 200));

        const radarResult = await captureWithDomtoimage(radarTabEl);
        radarCapture = radarResult;

        restoreRadar();
        radarTabEl.style.minWidth  = savedRadarMinWidth;
        radarTabEl.style.minHeight = savedRadarMinHeight;
        radarTabEl.style.position = savedRadarPos;
        radarTabEl.style.zIndex   = savedRadarZ;
        if (bgTabEl) { bgTabEl.style.position = savedBgPos; bgTabEl.style.visibility = savedBgVis; }
      }

      setCapturedReportData({
        organism,
        firstName,
        secondName,
        texts,
        metadata: {
          organism: `${firstName} ${secondName}`,
          country: actualCountry,
          timeInitial: actualTimeInitial,
          timeFinal: actualTimeFinal,
          genomes: actualGenomes,
          dataset,
          mapView: actualMapView,
          mapViewValue: mapView,
        },
        mapImage,
        bgCapture,
        bhpCapture,
        graphs: capturedGraphs,
        insightsCaptures: capturedInsights,
        radarCapture,
      });
      setPreviewOpen(true);
    } catch (error) {
      console.error('PDF capture error:', error);
      setShowAlert(true);
    } finally {
      dispatch(setLoadingPDF(false));
    }
  }

  function handleCloseAlert() {
    setShowAlert(false);
  }

  function handleClickDatabasePage() {
    let Name;
    if (organism === 'styphi') {
      Name = 'salmonella-typhi';
    } else if (organism === 'kpneumo') {
      Name = 'klebsiella-pneumoniae';
    } else if (organism === 'ngono') {
      Name = 'neisseria-gonorrhoeae';
    } else if (organism === 'shige') {
      Name = 'shigella-eiec';
    } else if (organism === 'decoli') {
      Name = 'diarrheagenic-e-coli';
    } else if (organism === 'sentericaints') {
      Name = 'invasive-non-typhoidal-salmonella';
    } else if (organism === 'saureus') {
      Name = 'staphylococcus-aureus';
    } else if (organism === 'strepneumo') {
      Name = 'streptococcus-pneumoniae';
    }
    const url = `https://amrnet.readthedocs.io/en/latest/usage.html#${Name}`;
    // console.log('url', url);
    window.open(url, '_blank');
    // window.open('https://amrnet.readthedocs.io/en/latest/', '_blank');
  }

  function buildCardSubtitle(cardId) {
    const ds = `${dataset}${dataset === 'All' && organism === 'styphi' ? ' (local + travel)' : ''}`;
    // Fall back to global time/genome values when card-specific redux state is uninitialised (0 / falsy)
    const safeGenomes = v => (v && v !== 0) ? v : actualGenomes;
    const safeStart   = v => (v && v !== 0) ? v : actualTimeInitial;
    const safeEnd     = v => (v && v !== 0) ? v : actualTimeFinal;
    if (cardId === 'GD')  return `Total: ${safeGenomes(actualGenomesGD)} genomes | Time period: ${safeStart(starttimeGD)} to ${safeEnd(endtimeGD)} | Country: ${actualCountry} | Dataset: ${ds}`;
    if (cardId === 'DRT') return `Total: ${safeGenomes(actualGenomesDRT)} genomes | Time period: ${safeStart(starttimeDRT)} to ${safeEnd(endtimeDRT)} | Country: ${actualCountry} | Dataset: ${ds}`;
    if (cardId === 'RDT') return `Total: ${safeGenomes(actualGenomesRDT)} genomes | Time period: ${safeStart(starttimeRDT)} to ${safeEnd(endtimeRDT)} | Country: ${actualCountry} | Dataset: ${ds}`;
    if (cardId === 'KOT') return `Total: ${safeGenomes(actualGenomesKOT)} genomes | Time period: ${safeStart(startTimeKOT)} to ${safeEnd(endTimeKOT)} | Country: ${actualCountry} | Dataset: ${ds}`;
    return `Total: ${actualGenomes} genomes | Time period: ${actualTimeInitial} to ${actualTimeFinal} | Country: ${actualCountry} | Dataset: ${ds}`;
  }

  return (
    <div className={classes.downloadDataWrapper}>
      <LoadingButton
        className={classes.button}
        variant="contained"
        onClick={handleClickDownloadDatabase}
        loading={loadingCSV}
        startIcon={<TableChart />}
        loadingPosition="start"
        disabled={organism === 'none'}
      >
        {t('downloadData.downloadDatabase')}
      </LoadingButton>
      <LoadingButton
        className={classes.button}
        variant="contained"
        onClick={handleClickDownloadPDF}
        loading={loadingPDF}
        startIcon={<LibraryBooksIcon />}
        loadingPosition="start"
        // disabled={['ecoli'].includes(organism)} //'styphi', 'kpneumo', 'ngono', 'sentericaints', 'senterica'
      >
        {t('downloadData.downloadPDF')}
      </LoadingButton>
      <Button
        className={classes.button}
        variant="contained"
        onClick={() => handleClickDatabasePage()}
        startIcon={<Storage />}
      >
        {/* Rename based on Feedback documnet 24 June */}
        {t('downloadData.infoAndDefinitions')}
      </Button>
      <PDFPreviewModal
        open={previewOpen}
        onClose={() => setPreviewOpen(false)}
        data={capturedReportData}
      />
      <Snackbar open={showAlert} autoHideDuration={5000} onClose={handleCloseAlert}>
        <Alert onClose={handleCloseAlert} severity="error" sx={{ width: '100%' }}>
          Something went wrong with the download, please try again later.
        </Alert>
      </Snackbar>
    </div>
  );
};
